module.exports = __webpack_public_path__ + "static/media/8.ba4de542.jpg";